import { useSearchParams } from "react-router";

import {
  type SortColumn,
  type SortDirection,
  isSortColumn,
  isSortDirection,
} from "@/shared/domain/files/FileService";

/**
 * Reads the file-browser sort state from the URL query string. Validates
 * `sortColumn` and `sortDirection` so downstream consumers (TanStack Query
 * keys, API requests) only ever see well-typed values; unknown or missing
 * params fall back to the default `{ name, ASC }` ordering.
 */
export function useSortParams(): {
  sortColumn: SortColumn;
  sortDirection: SortDirection;
} {
  const [searchParams] = useSearchParams();

  const sortColumnParam = searchParams.get("sortColumn");
  const sortDirectionParam = searchParams.get("sortDirection");

  const sortColumn: SortColumn =
    sortColumnParam !== null && isSortColumn(sortColumnParam)
      ? sortColumnParam
      : "name";

  const sortDirection: SortDirection =
    sortDirectionParam !== null && isSortDirection(sortDirectionParam)
      ? sortDirectionParam
      : "ASC";

  return { sortColumn, sortDirection };
}
